import * as React from 'react';
import {
    Show,
    SimpleShowLayout,
    TextField,
} from 'react-admin';
import AzureAuthenticationTitle from './AzureAuthenticationTitle';

const AzureAuthenticationShow = props => (
    <Show title={<AzureAuthenticationTitle />} {...props}>
        <SimpleShowLayout>
        <TextField source="id" />
            <TextField source="name" label="Name" />
            <TextField source="client_id" label="Client ID" />
            <TextField source="client_secret" label="Client secret" />
            <TextField source="tenant_id" label="Tenant ID" />
            <TextField source="subscription_id" label="Subscription ID" />
        </SimpleShowLayout>
    </Show>
);

export default AzureAuthenticationShow;